import React, { forwardRef, PropsWithChildren, useState } from 'react'
import { Box, BoxProps, Icon, chakra, useSlotRecipe } from '@chakra-ui/react'
import { convertIconSetToChakraSVG } from '../Icon/Icon.utils'
import { IconName } from '../Icon/Icon.types'
import { IconSizes } from '../../theme/iconSize'

export type StickyBannerProps = {
  icon?: IconName
  isClosable?: boolean
  variant?: string
}

const StickyContainer = forwardRef<HTMLDivElement, PropsWithChildren<BoxProps>>(
  function StickyContainer({ children, ...rest }, ref) {
    const recipe = useSlotRecipe({ key: 'stickyBanner' })
    const styles = recipe({})
    return (
      <Box ref={ref} css={styles.container} {...rest}>
        {children}
      </Box>
    )
  }
)

export default function StickyBanner({
  children,
  icon,
  isClosable,
  variant,
}: PropsWithChildren<StickyBannerProps>) {
  const recipe = useSlotRecipe({ key: 'stickyBanner' })
  const styles = recipe({ variant })
  const [isOpen, setIsOpen] = useState(true)

  if (!isOpen) {
    return null
  }

  const handleClose = () => {
    setIsOpen(false)
  }

  return (
    <Box css={styles.wrapper}>
      <Box maxWidth="container.xl" css={styles.banner} data-testid="sticky-banner">
        <Box css={styles.messageWrapper}>
          {icon ? (
            <Icon
              aria-hidden
              boxSize={IconSizes.lg}
              css={styles.icon}
              as={convertIconSetToChakraSVG(icon)}
            />
          ) : null}
          <Box css={styles.message}>{children}</Box>
        </Box>
        {isClosable ? (
          <chakra.button
            type="button"
            aria-label="close banner"
            onClick={handleClose}
            css={styles.crossIcon}
            background="none"
            border="0"
            padding="0"
            appearance="none"
            WebkitAppearance="none"
            lineHeight="0"
          >
            <Icon aria-hidden boxSize={IconSizes.md} as={convertIconSetToChakraSVG('cross')} />
          </chakra.button>
        ) : null}
      </Box>
    </Box>
  )
}

StickyBanner.StickyContainer = StickyContainer
